import { Injectable } from '@angular/core';
import { HttpApiService } from '../services/http-api.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private http: HttpApiService,
  ) { }

  authentication() {
    return this.http.get<Login>(`api/v1/authen/user/authentication`);
  }

  login(model: LoginModel) {
    return this.http.post<Login>(`api/v1/authen/user/signin`, model);
  }

  checkLogin(model: CheckLoginModel) {
    return this.http.post<CheckLoginResponse>(`api/v1/authen/user/check`, model)
  }
}

export interface LoginModel {
  username: string;
  password: string;
  remember: boolean;
  prefix: string;
}

export interface Login {
  Token: string;
}

export interface TwoFactorBinding {
  qrcode: string;
}

export interface CheckLoginModel {
  username: string;
}

export interface DataCheckLoginResponse {
  // -- บัญชีนี้ต้องกรอก OTP ตอน login (ทุกบัญชีที่ role ถูกต้อง ไม่ใช่เฉพาะ Superadmin)
  requires_2fa?: boolean;
  // -- ชื่อเดิมของ requires_2fa (API รุ่นเก่าส่งแค่ตัวนี้)
  is_super_admin: boolean;
  two_factor_bound: boolean;
  qr_url?: string;
  secret_key?: string;

}
export interface CheckLoginResponse {
  data: DataCheckLoginResponse
}

